import {store, getElement} from '@wordpress/interactivity';

const universalLock =
    'I acknowledge that using a private store means my plugin will inevitably break on the next store release.';

const {state: wooState} = store('woocommerce', {}, {lock: universalLock});
const {state: miniCartState} = store(
    'woocommerce/mini-cart',
    {},
    {lock: universalLock}
);

let cartUpdateTimeout = null;
let lastDispatchedCartJson = null;

const {state} = store('wc-stripe/mini-cart-express', {
    state: {
        isHydrated: false,
    },
    callbacks: {
        onInit() {
            state.isHydrated = true;
        },
        onDrawerOpen() {
            if (state.isHydrated && miniCartState.isOpen) {
                const {ref} = getElement();
                document.dispatchEvent(new CustomEvent('wc-stripe:mini-cart-ready', {
                    detail: {container: ref}
                }));
            }
        },
        onCartUpdated() {
            if (!state.isHydrated || !wooState.cart) {
                return;
            }
            const {ref} = getElement();
            clearTimeout(cartUpdateTimeout);
            cartUpdateTimeout = setTimeout(() => {
                const cartJson = JSON.stringify(wooState.cart);
                if (cartJson === lastDispatchedCartJson) {
                    return;
                }
                lastDispatchedCartJson = cartJson;
                if (ref.offsetHeight) {
                    ref.style.minHeight = ref.offsetHeight + 'px';
                }
                document.dispatchEvent(new CustomEvent('wc-stripe:mini-cart-updated', {
                    detail: {cart: wooState.cart, container: ref}
                }));
            }, 150);
        },
    },
});
